module.exports = __webpack_public_path__ + "img/img_value_3_h190.20263871.png";